import React from 'react';
import { Stack, Typography } from '@mui/material';
// ICONS
import CircleIcon from '@mui/icons-material/Circle';
// COMPONENTS
import DetailViewCard from '../../../../components/Card/DetailViewCard';
// HELPERS
import { getSubjectColor } from '../../../../helper';
// CONSTANTS
import { TP_COLORS } from '../../../../constants';

export interface IImageContainer {
  subjectCode: string;
  subject: string;
  subTopics: string[];
  curriculum: string;
  grade: string;
  style?: React.CSSProperties;
  isAssessment?: boolean;
}

const ImageContainer: React.FC<IImageContainer> = ({
  subject,
  subjectCode,
  subTopics,
  curriculum,
  grade,
  style = {},
  isAssessment = false,
}) => {
  return (
    <div
      style={{
        marginBottom: '30px',
        padding: '0 5%',
        background: `url('${
          process.env.PUBLIC_URL
        }/images/shapes/learning-gadgets.transparent.png') top right/contain no-repeat, ${getSubjectColor(
          subject
        )}`,
        ...style,
      }}
    >
      <div style={{ padding: '30px' }}>
        <Stack direction="row" justifyContent="flex-end">
          {isAssessment ? (
            <DetailViewCard
              title="Assessment"
              titleProps={{ variant: 'subtitle1', fontWeight: 600 }}
              containerProps={{
                sx: {
                  padding: '0px 8px',
                  backgroundColor: TP_COLORS.white,
                  color: TP_COLORS.black,
                  marginRight: '10px',
                },
              }}
            />
          ) : null}
          <DetailViewCard
            title={subjectCode}
            titleProps={{ variant: 'subtitle1', fontWeight: 600 }}
            containerProps={{
              sx: {
                padding: '0px 8px',
                backgroundColor: TP_COLORS.white,
                color: TP_COLORS.black,
              },
            }}
          />
        </Stack>
        <Typography variant="h4" sx={{ color: TP_COLORS.white }}>
          {subject}
        </Typography>
        {subTopics && subTopics.length
          ? subTopics.map((subTopic, index) => (
              <Typography
                key={index}
                variant="h6"
                fontWeight={600}
                className="ellipsis-text"
                sx={{ color: TP_COLORS.white, opacity: 0.5 }}
              >
                {subTopic}
              </Typography>
            ))
          : null}
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ color: TP_COLORS.white, opacity: 0.5 }}
        >
          {curriculum}&nbsp;&nbsp;
          <CircleIcon sx={{ width: '15px', height: '15px' }} />
          &nbsp;&nbsp;{grade}
        </Typography>
      </div>
    </div>
  );
};

export default ImageContainer;
